import React from "react"

import { RiStarHalfFill, RiStarFill } from "react-icons/ri"
interface IStarRating {
  value: number
  className?: string
}

export default function BreedStarRating({ value, className }: IStarRating) {
  const roundedValue = Math.round(value * 10) / 10

  const fullStars = Math.floor(roundedValue)

  const decimalPart = roundedValue - fullStars
  const hasHalfStar = decimalPart >= 0.5 && decimalPart < 0.6
  const nextFullStar = decimalPart >= 0.6

  const displayFullStars = fullStars + (nextFullStar ? 1 : 0)

  return (
    <div className={"flex" + " " + className}>
      {Array.from({ length: displayFullStars }, (_, i) => (
        <RiStarFill
          key={i}
          className="h-[21px] w-[21px] mr-0.5 fill-yellow-400"
        />
      ))}

      {hasHalfStar && !nextFullStar && (
        <RiStarHalfFill className="h-[21px] w-[21px] mr-0.5  fill-yellow-400" />
      )}

      {Array.from(
        {
          length: 5 - displayFullStars - (hasHalfStar && !nextFullStar ? 1 : 0),
        },
        (_, i) => (
          <RiStarFill
            key={displayFullStars + i + 1}
            className="h-[21px] w-[21px] mr-0.5 fill-gray-300"
          />
        ),
      )}
    </div>
  )
}

export function BreedHalfStarRating({ value, className }: IStarRating) {
  const roundedValue = Math.round(value * 10) / 10
  const fullStars = Math.floor(roundedValue)
  const decimalPart = roundedValue - fullStars
  const hasHalfStar = decimalPart >= 0.5 && decimalPart < 0.9
  const nextFullStar = decimalPart >= 0.9

  const totalFullStars = nextFullStar ? fullStars + 1 : fullStars

  return (
    <div className={`flex ${className}`}>
      {Array.from({ length: totalFullStars }, (_, i) => (
        <RiStarFill
          key={i}
          className="h-[21px] w-[21px] mr-0.5 fill-yellow-400"
        />
      ))}

      {hasHalfStar && !nextFullStar && (
        <RiStarHalfFill className="h-[21px] w-[21px] mr-0.5 fill-yellow-400" />
      )}

      {Array.from(
        {
          length: 5 - totalFullStars - (hasHalfStar && !nextFullStar ? 1 : 0),
        },
        (_, i) => (
          <RiStarFill
            key={totalFullStars + i + 1}
            className="h-[21px] w-[21px] mr-0.5 fill-gray-300"
          />
        ),
      )}
    </div>
  )
}
